import dynamic from 'next/dynamic';
import { RelatedSolutionsProps } from './RelatedSolutionsComponent';

const RelatedSolutionsComponent = dynamic(() => import('./RelatedSolutionsComponent'), {
    ssr: false,
});

export default function RelatedSolutionsComponentRender({
    solutions,
    currentSolutionKey,
}: RelatedSolutionsProps) {
    return (
        <RelatedSolutionsComponent solutions={solutions} currentSolutionKey={currentSolutionKey} />
    );
}
